import React from 'react'

import {
  CONVERSATION_FACTS_DIMENSIONS,
  useCubeReportAccessFiltersContext,
  useCubeReportPageFiltersContext,
} from 'cube'
import { ConversationCountDrillDownBaseQuery } from 'cube/queries/ConversationCountDrillDown.query'

import { Link } from '@driftt/dds'
import {
  CubeQueryBuilder,
  CubeQueryStringAdapter,
  KPICard,
} from '@driftt/dds.reports'

import { useTrackDrillDownClickEvent } from 'components/conversation/hooks/useTrackDrilldownClickEvent'
import useTimePeriod from 'hooks/useTimePeriod'
import { CONVO_DETAIL_REPORT_PATH } from 'layouts/ConversationsDetailReport/ConversationsDetailReport.constants'
import { TypeFormats } from 'utils/format'

import useConversationCount from './useConversationCount.hook'

export const ConversationCountKPICard = () => {
  const { metric, previousMetric, isLoading, hasNoData, hasError } =
    useConversationCount()
  const timePeriod = useTimePeriod()
  const { pageFilters } = useCubeReportPageFiltersContext()
  const { accessFilters } = useCubeReportAccessFiltersContext()

  const { trackViewEvent } = useTrackDrillDownClickEvent(
    'ConversationCountKPICard'
  )

  const drillDownCubeQuery = new CubeQueryBuilder({
    query: ConversationCountDrillDownBaseQuery,
  })
    .withFilters([...pageFilters, ...accessFilters])
    .withinDateRange(
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_AT,
      timePeriod?.startDate.toDate(),
      timePeriod?.endDate.toDate()
    )
    .build()

  const drillDownQueryString =
    CubeQueryStringAdapter.toQueryString(drillDownCubeQuery)

  return (
    <KPICard
      metric={metric}
      previousMetric={previousMetric}
      formatMetric={(totalConversations: number) =>
        TypeFormats.FIXED(totalConversations)
      }
      isLoading={isLoading}
      hasNoData={hasNoData}
      hasError={hasError}
    >
      <KPICard.Header
        title="Total chats"
        description="How many chats have occurred in Drift?"
      />
      <KPICard.Content>
        <KPICard.Metric />
        <Link
          target="_blank"
          variant="inline"
          href={`${CONVO_DETAIL_REPORT_PATH}?${drillDownQueryString}`}
          onClick={() => trackViewEvent({ totalRecords: metric ?? 0 })}
        >
          View data
        </Link>
      </KPICard.Content>
    </KPICard>
  )
}
